import { createContext } from "react";

export type THeaderCtx = {
  getCN: (element?: string, mods?: {
    [key: string]: boolean;
  }, utilClasses?: string[]) => string;
};

export const ctx = createContext<THeaderCtx>({
  getCN: () => "",
});
